import { CouponCheckJson } from "@/types/Coupon.type";
import { postActionCartPublic, postActionCartUser } from "../api/shop/cart";
import { useAppDispatch, useAppSelector } from "@/redux/hook";
import { CartAddEditJson, CartId } from "@/types/Cart.type";
import { ProductJson } from "@/types/Product.type";
import { setProductComparesState } from "@/redux/features/ShopSlice";
import Local from "@/common/constants/local";

export type ResultJson = {
  message: string;
  status: boolean;
};

const useCompareProduct = () => {
  const productCompares = useAppSelector(
    (state) => state.ShopReducer.productCompares
  );
  const dispatch = useAppDispatch();

  const generateNewIndex = (): number => {
    switch (productCompares.length) {
      case 0:
        return 0;
      case 1:
        if (productCompares.some((p) => p.index === 1)) {
          return 0;
        } else {
          return 1;
        }
      case 2:
        if (productCompares.every((p) => p.index !== 0)) {
          return 0;
        } else if (productCompares.every((p) => p.index !== 1)) {
          return 1;
        } else if (productCompares.every((p) => p.index !== 2)) {
          return 2;
        }
      default:
        return productCompares.length;
    }
  };

  const handleCompareProduct = ({
    product,
    type,
    chooseIndex,
  }: {
    product: ProductJson;
    type: "add" | "remove";
    chooseIndex: number;
  }): ResultJson => {
    if (type === "add") {
      if (productCompares.some((p) => p.product.id === product.id)) {
        // toast.info("Sản phầm đã có trong danh sách so sánh!");
        return {
          message: "Sản phầm đã có trong danh sách so sánh!",
          status: false,
        };
      } else {
        if (productCompares.length === 3) {
          // toast.info("Vui lòng xóa bớt sản phẩm để tiếp tục so sánh!");
          return {
            message: "Vui lòng xóa bớt sản phẩm để tiếp tục so sánh!",
            status: false,
          };
        } else {
          console.log("🥺 ~ useCompareProduct ~ chooseIndex:", chooseIndex);
          let newIndex = chooseIndex;
          console.log("🥺 ~ useCompareProduct ~ newIndex:", newIndex);

          let cloneProductCompares = [...productCompares];

          cloneProductCompares = [
            ...cloneProductCompares,
            { index: newIndex, product: product },
          ];

          dispatch(setProductComparesState(cloneProductCompares));

          localStorage.setItem(
            Local.storage.productCompare,
            JSON.stringify(cloneProductCompares)
          );
          // toast.success("Thêm sản phầm so sánh thành công!");
          return {
            message: "Thêm sản phầm so sánh thành công!",
            status: true,
          };
        }
      }
    } else {
      const productRemove = productCompares.find(
        (p) => p.product.id === product.id
      );
      if (productRemove) {
        let cloneCompareState = [...productCompares];
        cloneCompareState = cloneCompareState.filter(
          (p) => p.product.id !== productRemove.product.id
        );
        dispatch(setProductComparesState(cloneCompareState));

        localStorage.setItem(
          Local.storage.productCompare,
          JSON.stringify(cloneCompareState)
        );
        // toast.success("Đã gỡ sản phầm thành công!");
        return {
          message: "Đã gỡ sản phầm thành công!",
          status: true,
        };
      }
    }
    return {
      message: "Unknown",
      status: false,
    };
  };

  return {
    handleCompareProduct,
    generateNewIndex,
  };
};

export default useCompareProduct;
